// User model 
export default class User{
    constructor(fullName, email, password){
        this.name = fullName,
        this.email = email,
        this.password = password
    }
}